import script from "./walletSelectPop.vue?vue&type=script&setup=true&lang=js"
export * from "./walletSelectPop.vue?vue&type=script&setup=true&lang=js"

import "./walletSelectPop.vue?vue&type=style&index=0&id=5aa47c7c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa47c7c"]])

export default __exports__